import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

export const SCCalibrateContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;

  @media (min-width: 768px) {
    z-index: -2;
    background-color: black;
  }
`

export const SCVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
  touch-action: pinch-zoom;
`

interface overlayProps {
  $size: number
}

export const SCOverlayImage = styled.img<overlayProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: ${({ $size }) => `${$size}px`};
  max-height: ${({ $size }) => `${$size}px`};
  z-index: 2;
  pointer-events: none;

  @media (min-width: 768px) and (orientation: portrait) {
    max-width: 90%;
    max-height: 95%;
  }

  @media (min-width: 768px) and (orientation: landscape) {
    max-width: 70%;
    max-height: 90%;
  }
`

export const SCCalibrateZoom = styled.div`
  position: absolute;
  color: white;
  top: ${pxToRem(85)};
  right: ${pxToRem(20)};
  z-index: 10;

  @media (min-width: 768px) and (orientation: portrait) {
    right: ${pxToRem(20)};
  }

  @media (min-width: 768px) and (orientation: landscape) {
    right: ${pxToRem(150)};
  }
`

export const SCCalibrateSpan = styled.span`
  margin: 0 8px;

  @media (min-width: 768px) and (orientation: portrait) {
    font-size: ${pxToRem(18)};
  }

  @media (min-width: 768px) and (orientation: landscape) {
    font-size: ${pxToRem(18)};
  }
`
